import BResultsBacteria from './BResultsBacteria'

export default BResultsBacteria
